// @ts-check
import LoadMoreButton from './LoadMoreButton';

export default LoadMoreButton;
